/* eslint-disable max-len */
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Spin } from 'antd';

import CardC from 'src/components/Card';
import Chip from 'src/components/Chip';
import ErrorNetwork from 'src/components/Error/ErrorNetwork';
import EventCard from 'src/components/EventCard';
import EmptyC from 'src/components/Layout/Empty';
import SpinC from 'src/components/Layout/Spin';
import { useListEvent } from 'src/hooks/Events/useListEvent';
import useTCList from 'src/hooks/Events/useTCList';
import { useUrlMultiSearchState } from 'src/hooks/useUrlMultiSearchState';

const Events = () => {
	const { states, updateKey, query, debouncedStates } = useUrlMultiSearchState({
		category: undefined,
		search: '',
	});

	const selectedCategoryCode = states?.category || query?.category || undefined;
	const search = debouncedStates?.search || query?.search || '';

	const payload = {
		...(selectedCategoryCode ? { tc_code: selectedCategoryCode } : {}),
		...(search ? { name: search } : {}),
	};

	const {
		data: onGoingData,
		fetchNextPage: fetchNextOngoing,
		hasNextPage: hasNextOngoing,
		isError: isErrorOngoing,
		isLoading: isLoadingOngoing,
	} = useListEvent('ongoing', payload);
	const {
		data: upComingData,
		fetchNextPage: fetchNextUpcoming,
		hasNextPage: hasNextUpcoming,
		isError: isErrorUpcoming,
		isLoading: isLoadingUpcoming,
	} = useListEvent('upcoming', payload);

	const { data: categories } = useTCList();

	if (isErrorOngoing || isErrorUpcoming) {
		return (
			<div className="mx-auto max-w-lg">
				<CardC className="container mb-12">
					<ErrorNetwork />
				</CardC>
			</div>
		);
	}

	const isOngoingDataAvailable = onGoingData && onGoingData?.length > 0;
	const isUpComingDataAvailable = upComingData && upComingData?.length > 0;

	return (
		<div className="container min-h-screen flex flex-col gap-12 mb-12">
			<h2 className="mt-6 md:mt-10 text-xl md:text-2xl font-bold text-center text-neutral-3">
				KALBE EVENT HUB
			</h2>
			<div className="flex flex-col gap-4">
				<Input
					placeholder="Cari event"
					size="middle"
					prefix={<SearchOutlined className="text-neutral-5" />}
					value={states?.search}
					onChange={(e) => updateKey('search', e.target.value)}
					allowClear
					className="rounded-xl px-3 py-2 text-sm text-neutral-7"
				/>
				{categories && categories?.length > 0 && (
					<div className="flex flex-row overflow-x-auto flex-nowrap space-x-2 py-2 mb-4 scrollbar-hidden">
						<Chip
							text="Semua"
							theme={selectedCategoryCode === undefined ? 'primary' : 'neutral'}
							active={selectedCategoryCode === undefined}
							icon={false}
							onClick={() => updateKey('category', '')}
						/>
						{categories.map((category) => (
							<Chip
								key={category.code}
								text={category.name}
								theme={selectedCategoryCode === category.code ? 'primary' : 'neutral'}
								active={selectedCategoryCode === category.code}
								icon={false}
								onClick={() => updateKey('category', category.code)}
							/>
						))}
					</div>
				)}
			</div>
			{isOngoingDataAvailable && (
				<div className="flex flex-col gap-6">
					<h3 className="text-lg md:text-xl font-semibold italic text-neutral-3">
						Sedang Berlangsung
					</h3>
					<InfiniteScroll
						dataLength={onGoingData.length}
						next={fetchNextOngoing}
						hasMore={!!hasNextOngoing}
						loader={
							<div className="w-full flex justify-center">
								<Spin size="large" />
							</div>
						}
						className="flex flex-col gap-6"
					>
						{onGoingData.map((e) => (
							<EventCard
								key={e.name}
								title={e.name}
								description={e.description}
								date={e.jadwal}
								imageUrl={e.images || '/icons/512x512.png'}
								location={e.location}
								participants={e.quota}
								slug={e.slug}
								showButton={e.is_show_button_reg}
							/>
						))}
					</InfiniteScroll>
				</div>
			)}
			{isUpComingDataAvailable && (
				<div className="flex flex-col gap-6">
					<div>
						<h3 className="text-lg md:text-xl font-semibold italic text-neutral-3 mb-1">
							Event yang akan datang
						</h3>
						<p className="text-neutral-7 text-sm md:text-base">
							Jangan lewatkan berbagai acara menarik yang akan datang
						</p>
					</div>
					<InfiniteScroll
						dataLength={upComingData.length}
						next={fetchNextUpcoming}
						hasMore={!!hasNextUpcoming}
						loader={
							<div className="w-full flex justify-center">
								<SpinC />
							</div>
						}
						className="flex flex-col gap-6"
					>
						{upComingData.map((e) => (
							<EventCard
								key={e.name}
								title={e.name}
								description={e.description}
								date={e.jadwal}
								imageUrl={e.images || '/icons/512x512.png'}
								location={e.location}
								participants={e.quota}
								slug={e.slug}
								showButton={e.is_show_button_reg}
							/>
						))}
					</InfiniteScroll>
				</div>
			)}
			{!isLoadingOngoing &&
				!isLoadingUpcoming &&
				!isOngoingDataAvailable &&
				!isUpComingDataAvailable && (
					<div className="mx-auto max-w-lg">
						<CardC className="container mb-5">
							<EmptyC
								title="Event tidak ditemukan"
								buttonHidden
								buttonText=""
								image="/images/empty/help.svg"
								customHeaderEmpty="text-base md:text-xl font-semibold text-neutral-5"
							/>
						</CardC>
					</div>
				)}
		</div>
	);
};

export default Events;
